const ToolboxInfo = {
  maxInstances: {
    character_motion_jump: 1,
    procedures_defnoreturn: 2,
    procedures_callnoreturn_1: 2,
    procedures_callnoreturn_2: 2,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "character_motion_jump",
          },
          {
            kind: "block",
            type: "procedures_defnoreturn",
            fields: {
              NAME: "なにかする",
            },
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
